import { useState } from 'react';
import { useApi } from '../api/useApi';
import { mediaUrl } from '../api/client';
import Loader from './ui/Loader';
import SectionHeader from './ui/SectionHeader';

function BlogModal({ post, onClose }) {
  if (!post) return null;

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="blog-modal-title">
      <button type="button" className="modal__backdrop" aria-label="Cerrar" onClick={onClose} />
      <div className="modal__dialog">
        <button type="button" className="modal__close" onClick={onClose} aria-label="Cerrar">
          ×
        </button>
        {post.image_url ? (
          <img src={mediaUrl(post.image_url)} alt="" className="modal__image" />
        ) : null}
        <div className="modal__body">
          <p className="modal__meta">
            {post.author} · {post.published_at}
          </p>
          <h3 id="blog-modal-title" className="modal__title">
            {post.title}
          </h3>
          <p className="modal__text">{post.content}</p>
        </div>
      </div>
    </div>
  );
}

export default function Blog() {
  const { data: posts, loading } = useApi('/blog', 'blog');
  const [activePost, setActivePost] = useState(null);

  return (
    <section className="section section--blog" id="blog">
      <div className="container">
        <SectionHeader
          eyebrow="Blog"
          title="Actualidad jurídica"
          subtitle="Artículos y análisis para mantenerte informado sobre temas legales relevantes."
        />

        {loading ? (
          <Loader />
        ) : (
          <div className="blog-grid">
            {posts?.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-card__media">
                  <img src={mediaUrl(post.image_url)} alt="" loading="lazy" />
                </div>
                <div className="blog-card__body">
                  <p className="blog-card__meta">
                    {post.author} · {post.published_at}
                  </p>
                  <h3 className="blog-card__title">{post.title}</h3>
                  <p className="blog-card__excerpt">{post.excerpt}</p>
                  <button type="button" className="blog-card__link" onClick={() => setActivePost(post)}>
                    Leer más
                  </button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>

      <BlogModal post={activePost} onClose={() => setActivePost(null)} />
    </section>
  );
}
